import { render, staticRenderFns } from "./userOkr.vue?vue&type=template&id=ede54d4c"
import script from "./userOkr.vue?vue&type=script&lang=js"
export * from "./userOkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports